import { render, staticRenderFns } from "./quality-control-detail.vue?vue&type=template&id=0ddc07f7&"
import script from "./quality-control-detail.vue?vue&type=script&lang=js&"
export * from "./quality-control-detail.vue?vue&type=script&lang=js&"
import style0 from "./quality-control-detail.vue?vue&type=style&index=0&id=0ddc07f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports